import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=70ade420&scoped=true"
import script from "./MessageCard.vue?vue&type=script&lang=ts"
export * from "./MessageCard.vue?vue&type=script&lang=ts"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=70ade420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ade420",
  null
  
)

export default component.exports